import dynamic from "next/dynamic";
import AppleLogin from "./AppleLogin";
import { useState } from "react";
import Loading from "assets/lottie/loading";
import { useAppContext } from "@context/app";
import { IUserLoginInput } from "@types";
import { segmentGetAnonymousId, segmentEvent, setSegmentIdentifyPhoneNumber } from "@utils/segment";
import { setExternalUserId } from "@utils/oneSignal";
import { useRouter } from "next/router";
const GoogleLogin = dynamic(() => import("./GoogleLogin"), { ssr: false });
// const FacebookLogin = dynamic(() => import("./FacebookLogin"), { ssr: false });

interface SocialLoginProps {
  action: "login" | "register" | "guest"
}
type SocialType = 'apple' | 'google' | 'facebook';

const SocialLogin: React.FC<SocialLoginProps> = ({ action }) => {
  const [isLoading, setIsLoading] = useState(false)
  const { setUserLoggedIn, country, area } = useAppContext();
  const { locale, pathname } = useRouter();

  const handleEvent = (data: IUserLoginInput, socialType: SocialType) => {
    if (data.new_user) {
      registerEvent(data, socialType)
    } else {
      loginEvent(data, socialType)
    }
  }
  let from_page: string;
  if (pathname === "/cart") {
    from_page = "cart";
  } else if (pathname === "/product/[slug]") {
    from_page = "product_details";
  } else {
    from_page = "menu";
  }

  const loginEvent = (user: IUserLoginInput, socialType: SocialType) => {
    setExternalUserId(`${user.user.id}`, user.user.os_id_hash)
    setSegmentIdentifyPhoneNumber(user.user, segmentGetAnonymousId())
    segmentEvent("User Logged In", {
      user_id: user.user.id || -1,
      action: "Normal",
      language: locale?.includes("en") ? "English" : "Arabic",
      country_id: country?.id,
      country_slug: country?.slug,
      area_id: area?.id,
      area_slug: area?.slug,
      from_page: from_page,
      from_entity: "",
      from_entity_slug: "",
      from_page_section: "",
      from_page_section_entity: "",
      from_page_section_slug: "",
      social_login: socialType
    });
    setUserLoggedIn({ isLoggedIn: true });
  }


  const registerEvent = (user: IUserLoginInput, socialType: SocialType) => {
    setExternalUserId(`${user.user.id}`)
    setSegmentIdentifyPhoneNumber(user.user, segmentGetAnonymousId())
    segmentEvent("User Registered", {
      user_id: user.user.id || -1,
      action: "Register",
      language: locale?.includes("en") ? "English" : "Arabic",
      country_id: country?.id,
      country_slug: country?.slug,
      area_id: area?.id,
      area_slug: area?.slug,
      from_page: from_page,
      from_entity: "",
      from_entity_slug: "",
      from_page_section: "",
      from_page_section_entity: "",
      from_page_section_slug: "",
      social_login: socialType
    });
    segmentEvent("User Logged In", {
      user_id: user.user.id || -1,
      action: "Register",
      language: locale?.includes("en") ? "English" : "Arabic",
      country_id: country?.id,
      country_slug: country?.slug,
      area_id: area?.id,
      area_slug: area?.slug,
      from_page: from_page,
      from_entity: "",
      from_entity_slug: "",
      from_page_section: "",
      from_page_section_entity: "",
      from_page_section_slug: "",
      social_login: socialType
    });
    setUserLoggedIn({ isLoggedIn: true });
  }
  return (
    <div className="w-full flex items-center justify-center space-x-2 flex-wrap ">
      {isLoading && <Loading isCenter />}
      <AppleLogin onLoad={setIsLoading} handleEvent={handleEvent} />
      <GoogleLogin onLoad={setIsLoading} handleEvent={handleEvent} />
      {/* <FacebookLogin onLoad={setIsLoading} handleEvent={handleEvent} /> */}
    </div>
  );
}

export default SocialLogin;